































































































import Vue from 'vue';
import { AllGeeksMultipleSelect } from '@/components';
import { GeekItem } from '@/models';
import { GCoinsAdminActionForm } from '@/models/admin-panel';
import { GeeksBalance } from '@/models/gcoins';
import { typedStore, Actions, Getters } from '@/store';
import { ToastsService, resetModel } from '@/utils';

export default Vue.extend({
  name: 'AddGCoinsTab',
  components: {
    AllGeeksMultipleSelect,
  },
  data() {
    return {
      loader: {
        isRequestPending: false,
      },
      geekIds: [] as string[],
      geekBalance: { balance: null, id: '' } as unknown as GeeksBalance,
      form: {
        gCoins: null as unknown as number,
        reason: '',
      },
      predefinedValues: [
        20,
        40,
        200,
      ],
    };
  },
  computed: {
    gCoinsSum(): number {
      return +this.geekBalance.balance + +this.form.gCoins;
    },
    isGCoinsValueValid(): boolean {
      return !(this as any).errors.items.find((i: any) => i.field === 'g-coins');
    },
    filteredGeeks(): GeekItem[] {
      return typedStore(this).getters[Getters.geek.filtered];
    },
  },
  methods: {
    async addGCoins() {
      const isFormValid = await this.$validator.validate();
      if (!isFormValid) {
        return;
      }

      this.loader.isRequestPending = true;
      try {
        for (const id of this.geekIds) {
            const formData = { ...this.form, geekId: id } as GCoinsAdminActionForm;
            await this.$store.dispatch(Actions.gCoins.addGCoins, formData);
        }
        ToastsService.success(this.$t('admin-panel.gcoins.tabs.add.gcoins-added-toast') as string);
        this.resetModels();
        (this as any).$refs.geekSelect.clearSelected();
      } finally {
        this.loader.isRequestPending = false;
      }
    },
    async updateSelectedGeeks(geekItems: GeekItem[]) {
      if (geekItems) {
        const geekIds = geekItems.map(g => g.id);
        this.geekIds = [] as string[];
        this.geekIds = geekIds;
        if (geekIds.length === 1) {
          try {
            const geekFound = await this.$store.dispatch(
            Actions.gCoins.fetchGeeksBalanceEntries,
            { geekId: geekIds[0] });
            this.geekBalance = geekFound.data[0];
          } finally {
            this.loader.isRequestPending = false;
          }
        }
        await this.$validator.reset();
      } else {
         this.resetModels();
      }
    },
    resetModels() {
      this.form = resetModel(this.form);
      // ensure the form is empty before ui re-render
      requestAnimationFrame(async () => {
        this.geekBalance = { balance: null, id: '' } as unknown as GeeksBalance,
        await this.$validator.reset();
      });
    },
    applyValue(value: number) {
      this.form.gCoins = value;
    },
  },
  watch: {
    'loader.isRequestPending': {
      handler(this: any) {
        this.$emit('changeLoaderStatus', this.loader.isRequestPending);
      },
    },
  },
});
